<template>
  <Row :gutter="20">
    <i-col :xs="24" :sm="12" :md="6">
      <CardCounter :count="statsData.published" imgSrc="icons/published.svg" text="Published" styles="color:#fff;background:#7F7F7F;"/>
    </i-col>
    <i-col :xs="24" :sm="12" :md="6">
      <CardCounter :count="statsData.pending" imgSrc="icons/pending-approval.svg" text="Pending Approval" styles="color:#fff;background:#595959;"/>
    </i-col>
    <i-col :xs="24" :sm="12" :md="6">
      <CardCounter :showCounter="false" imgSrc="icons/submit-article.svg" text="Submit my article" styles="color:#fff;background:#404040;" class="clickable" @click.native="redirectTo"/>
    </i-col>
    <i-col :xs="24" :sm="12" :md="6">
      <CardCounter :count="statsData.expired" imgSrc="icons/expired.svg" text="Expired" styles="color:#fff;background:#737373;"/>
    </i-col>
  </Row>
</template>

<script>
import CardCounter from '@/components/ui/CardCounter'

export default {
  props: {
    statsData: {
      type: Object,
      default: () => {}
    }
  },

  components: {
    CardCounter
  },

  methods: {
    redirectTo () {
      window.open('https://kromnix.com/solutions/tech-providers/submit-your-article/', '_blank')
    }
  }
}
</script>
